<template>
  <div style="background-color: #f6f6f6;">
    <van-nav-bar title="建议有奖" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <div>
      <van-cell-group>
        <van-field
          v-model="info"
          label="建议内容"
          rows="5"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="请输入留言"
          show-word-limit
        />
      </van-cell-group>
      <van-button size="large" type="danger" v-on:click="clickJianYi()">提交</van-button>
    </div>
    <div class="photos">
      <van-uploader
        v-model="fileList"
        :preview-image="true"
        :before-read="beforeRead"
        :after-read="afterRead"
        max-count="5"
      />
    </div>
    <div style="height:46px"></div>
    <TabBar active="4" />
  </div>
</template>
<script>
import Vue from "vue";
import TabBar from "@/components/TabBar.vue";
import { Uploader } from "vant";

Vue.use(Uploader);
export default {
  name: "money",
  components: {
    TabBar
  },
  data() {
    return {
      list: [],
      user: { token: "", user: {} },
      info: "",
      fileList: [],
      img: []
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";

      var formData = new FormData();
      formData.append("file", file.file);
      this.$http
        .post(this.GLOBAL.API + "s_user/message/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "XX-Token": this.user.token,
            "XX-Device-Type": "mobile"
          },
          processData: false,
          contentType: false
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            (file.status = "done"), this.img.push(data.data);
          } else {
            this.$toast(data.msg);
          }
        });
    },
    beforeRead() {
      return true;
    },
    clickJianYi() {
      this.$http
        .post(
          this.GLOBAL.API + "s_user/message/feedback",
          { content: this.info, img: this.img[0] },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          this.onLoad();
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: left;
  .item {
    background-color: #fff;
    display: flex;
    padding: 10px 10px 0 10px;
    margin-top: 10px;
    justify-content: space-between;

    .title {
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0 5px 0 5px;
    }
    .price {
      color: #1baeae;;
      text-align: right;
      padding: 0 5px 0 5px;
    }
  }
}
.photos {
    background-color: #fff;
  padding: 10px;
  text-align: left;
}
</style>